import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const Percentage: ConvertableUnit = {
  label: "%",
  toStandardUnit: p => p,
  toThisUnit: p => p
};

export const Ratio: ConvertableUnit = {
  label: "",
  toStandardUnit: d => d * 100,
  toThisUnit: p => p / 100
};

const unitList = [Percentage];
export const PercentageUnits = {
  Percentage,
  Ratio,
  options: buildOptions(unitList)
};
